<template>
  <div class="SectionAboutSigRtb">
    <Wrap class="xl">
      <div class="body">
        <h3>
          {{ $t('title') }}
        </h3>
        <div class="text">
          <p v-for="paragraph in $ta('paragraphs')" :key="paragraph">
            {{ injectSnippets(paragraph) }}
          </p>
        </div>
        <Btn :to="{ name: 'Index' }">
          {{ $t('cta') }}
        </Btn>
      </div>
    </Wrap>
  </div>
</template>

<script>
import { getters } from 'views/utils'

export default {
  computed: getters('injectSnippets'),
}
</script>

<style lang="scss">
.SectionAboutSigRtb {
  padding: 2rem 0;
  .body {
    padding: 3rem 0;
    .text {
      margin: 1rem 0;
      p {
        margin-bottom: 1rem;
      }
    }
    .Btn {
      margin-top: 1rem;
    }
  }
}
</style>

<i18n>
{
  "pl": {
    "title": "Sun Investment Group – lider branży budowy farm fotowoltaicznych",
    "paragraphs": [
      "Sun Investment Group (SIG) to założona w 2017 roku firma zajmująca się rozwojem i budową projektów fotowoltaicznych. SIG koncentruje się na aktywach energii słonecznej na rynkach inwestycyjnych niskiego ryzyka. Portfolio firmy składa się ze {constructedMw} MW zainstalowanej mocy. SIG znalazł się w rankingu Top 50 European Solar Portfolios 2020 (Solarplaza). Projekty o łącznej mocy ponad 1000 MW znajdują się obecnie w fazie rozwoju. SIG posiada bogate doświadczenie w sektorze energii słonecznej we Włoszech Hiszpanii, Polsce oraz w regionie bałtyckim. Grupa Kapitałowa Sun Investment Group jest postrzegana jako jeden z liderów rynku w regionie."
    ],
    "cta": "Więcej informacji"
  }
}
</i18n>
